import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
 

export default function ECard({ title, content, loading, icon: IconComponent }) {
  return (
    <div className="relative surface-ground border-round shadow-3 w-full h-auto overflow-hidden">
      {/* Yükleme Perdesi */}
      {loading && (
        <div className="absolute w-full h-full bg-gray-900 opacity-50 flex align-items-center justify-content-center z-5">
          <ProgressSpinner className="w-3 h-3" />
        </div>
      )}

      {/* Kart İçeriği */}
      <div className={loading ? "opacity-50 p-4 flex flex-column gap-3" : "p-4 flex flex-column gap-3  "}>
        {/* Başlık ve İkon */}
        <div className="flex justify-content-between gap-3 ">
       
          <span className="font-bold text-2xl">{title}</span>
          {IconComponent && (
           IconComponent
          )}
        </div>

        {/* Kart İçeriği */}
        <div className="text-base text-gray-700 mt-2">
          {content}
        </div>
      </div>
    </div>
  );
}

 
